import PdfExtratoCliente from "./PdfExtratoCliente";

function PdfExtratoClienteWrapper({ showPreviousPage, dados }) {
  const showPreviousP = () => {
    showPreviousPage();
  };

  return (
    <div>
      <PdfExtratoCliente dados={dados} showPreviousPage={showPreviousP} />
    </div>
  );
}

export default PdfExtratoClienteWrapper;
